import { GLOBAL } from '../config'
import { type BrowserEmbedSettings, BrowserEmbedder } from '../browser/browser-embedder'
import { version } from '../../package.json'

export function installGlobally (settings: Partial<BrowserEmbedSettings>): BrowserEmbedder {
  // save BrowserEmbedder in window[globalName]
  const globalName = settings.global ?? GLOBAL

  const existingModule = (window as any)[globalName]

  // If the module does not exist, create a new one and save it in the window
  if (existingModule == null) {
    (window as any)[globalName] = new BrowserEmbedder(settings)
  } else if (existingModule.version !== version) {
    throw new Error(`The version does not match: ${existingModule.version as string}, ${version}`)
  }
  return (window as any)[globalName]
}
